import { Button } from "@mui/material";
import { useFormikContext } from "formik";
import { ReactElement } from "react";

import { FlexBox } from "~frontend/components/FlexBox";
import { FormikSubmitButton } from "~frontend/components/forms/SubmitButton";
import theme from "~frontend/theme";

export default function ContactImportFormSubmitButtons({
  resetContactSourceSettings,
  readOnly,
  submitDisabledText,
}: {
  resetContactSourceSettings: (() => void) | null;
  readOnly?: boolean;
  submitDisabledText?: string;
}): ReactElement | null {
  const formik = useFormikContext();

  if (readOnly) {
    return null;
  }

  return (
    <FlexBox sx={{ justifyContent: "flex-end" }}>
      {resetContactSourceSettings && formik.dirty ? (
        <Button
          sx={{
            mx: 2,
            fontSize: "10px",
            padding: "6px 8px",
            height: "auto",
          }}
          variant="contained"
          color="tertiary"
          onClick={() => {
            formik.resetForm();
            resetContactSourceSettings();
          }}
        >
          Discard Changes
        </Button>
      ) : null}
      <FormikSubmitButton
        disabled={readOnly || !!submitDisabledText || !formik.isValid}
        tooltipText={submitDisabledText}
        submitText={
          resetContactSourceSettings ? "Reload Contacts" : "Load Contacts"
        }
        loadingText={
          resetContactSourceSettings
            ? "Reloading Contacts..."
            : "Loading Contacts..."
        }
        onClick={() => {
          formik.submitForm().catch(console.error);
        }}
        sx={{
          minWidth: theme.spacing(20),
          fontSize: "10px",
          padding: "6px 8px",
          height: "auto",
        }}
      />
    </FlexBox>
  );
}
